<template>
  <div>
    <h1 class="mb-4 font-bold text-3xl">Umowy</h1>
    <div class="mb-4 text-sm">
      <div class="inline" v-if="!form.user">
        <inertia-link class="mr-2 text-blue-500 focus:text-shtax-500 hover:text-shtax-500" :href="route('contracts', new_query({trashed: 'with'}))">
          <span>Wszystkie</span>
        </inertia-link><span class="mr-3">({{ stats.all.value }})</span>|
      </div>
      <div class="inline" v-else>
        <inertia-link class="mx-2 text-blue-500 focus:text-shtax-500 hover:text-shtax-500" :href="route('contracts', new_query({trashed: 'with', 'user[id]': form.user.id, 'user[name]': form.user.name}, ['signed']))">
          <span>{{ form.user.name }}</span>
        </inertia-link><span class="mr-3">({{ stats.user.value }})</span>|
      </div>
      <inertia-link class="mx-2 text-blue-500 focus:text-shtax-500 hover:text-shtax-500" :href="route('contracts', new_query({trashed: 'with', signed: 'true'}))">
        <span>Podpisane</span>
      </inertia-link><span class="mr-3">({{ stats.signed.value }})</span>|
      <inertia-link class="mx-2 text-blue-500 focus:text-shtax-500 hover:text-shtax-500" :href="route('contracts', new_query({}, ['trashed', 'signed']))">
        <span>Aktywne</span>
      </inertia-link><span class="mr-3">({{ stats.active.value }})</span>|
      <inertia-link class="mx-2 text-blue-500 focus:text-shtax-500 hover:text-shtax-500" :href="route('contracts', new_query({trashed: 'only'}, ['signed']))">
        <span>Wypowiedziane</span>
      </inertia-link><span class="mr-3">({{ stats.deleted.value }})</span>
    </div>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Umowy:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Aktywne i usunięte</option>
          <option value="only">Tylko usunięte</option>
        </select>

        <div v-if="$page.props.can['manage all clients']">
          <label class="pt-4 block text-gray-700">Opiekun:</label>
          <multiselect-input v-model="form.user" class="mt-1 w-full" :options="users_opt" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
        </div>

        <shtax-checkbox class="pt-6 w-full" v-model:checked.sync="form.signed" :checked="form.signed" label="Podpisane" />
      </search-filter>
      <inertia-link class="btn-shtax ml-auto disabled:opacity-50" :href="route('contracts.onlycreate')">
        <span>Nowa</span>
        <span class="hidden md:inline">umowa</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-6 pb-4">Numer</th>
          <th class="px-3 pt-6 pb-4">Kontrahent</th>
          <th class="px-3 pt-3 pb-2">Data<br>podpisania</th>
          <th class="px-3 pt-6 pb-4">Usługa od</th>
          <th class="px-3 pt-6 pb-4">Cenniki</th>
          <th class="px-3 pt-6 pb-4">Cennik<br>promocyjny</th>
          <th class="px-3 pt-6 pb-4">Szablon</th>
          <th class="px-3 pt-6 pb-4">Uwagi</th>
          <th class="px-3 pt-6 pb-4" colspan="2">Wydruk</th>
        </tr>
        <tr v-for="contract in contracts.data" :key="contract.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-red-50':contract.deleted_at != null, 'bg-orange-50':contract.deleted_a == null && contract.signed_at == null}">
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':contract.client_id,'contract':contract.id})">
                <span>
                  {{ contract.number }}
                  <icon v-if="contract.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
                </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal" :href="route('contracts.edit', {'client':contract.client_id,'contract':contract.id})">
              {{ contract.firma }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':contract.client_id,'contract':contract.id})">
              {{ contract.signed_at }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':contract.client_id,'contract':contract.id})">
              {{ contract.started_from }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':contract.client_id,'contract':contract.id})">
              {{ contract.price_list }}<br>{{ contract.price_list_kadry }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':contract.client_id,'contract':contract.id})">
              <template v-if="contract.has_promotion">
              Tak do: {{ contract.promotion_ends_on }}
              </template>
              <template v-else>Nie</template>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':contract.client_id,'contract':contract.id})">
              {{ contract.theme }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':contract.client_id,'contract':contract.id})">
              {{ contract.uwagi }}
            </inertia-link>
          </td>
          <td class="border-t">
            <a class="px-3 py-2 flex items-center focus:text-shtax-500" :href="contract.pdf_url" target="_blank">
              <fa icon="print" fixed-width />
            </a>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('contracts.edit', {'client':contract.client_id,'contract':contract.id})" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="contracts.data.length === 0">
          <td class="border-t px-3 py-2" colspan="10">Nie znaleziono umów.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-3" :links="contracts.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/ShtaxComponents/SearchFilter'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'

export default {
  metaInfo: { title: 'Umowy' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    MultiselectInput,
    ShtaxCheckbox
  },
  layout: Layout,
  props: {
    filters: Object,
    contracts: Object,
    users: Array,
    stats: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        user: this.filters.user ?? (this.$page.props.can['manage all clients'] ? null : {'id': this.$page.props.auth.user.id, 'name': this.$page.props.auth.user.first_name +' '+ this.$page.props.auth.user.last_name}),
        signed: this.filters.signed == 'true'
      },
      users_opt: this.users.map(user => {return {'id': user.id, 'name': user.first_name +' '+ user.last_name}}),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('contracts'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },

    new_query(obj, except = []) {
      let r = (window.location.search)
        .replace('?', '')
        .replace('%20', ' ')
        .split('&')
        .map(param => param.split('='))
        .reduce((values, [ key, value ]) => {
          values[ key ] = value
          return values
        }, {})
      
      let new_obj = {...r, ...obj}
      if (except.length == 0)
        return new_obj;

      except.forEach(function(key) {
        delete new_obj[key];
      })
      return new_obj;
    }
  }
}
</script>
